(function() {
    const node = document.getElementById('friday-navbar');

    const run = function() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        if (scrollTop > 100) {
            node.style.display = 'block';
            node.style.opacity = Math.min(1, (scrollTop - 100) / 100);
        } else {
            node.style.display = 'none';
        }
    };

    document.addEventListener('scroll', function() {
        run();
    }, { passive: true });
    run();
})();